import { ArticleEmbedStateEnum } from '@/Domain/api/KnowledgeBase/dto/EmbedState.dto';

export enum ArticleState {
  PENDING = 'pending',
  PREVIEW = 'preview',
  DONE = 'done',
  REFRESH_FAILED = 'refresh_failed',
}

export interface Article {
  id: string;
  title: string;
  url: string;
  content: string;
  created_timestamp: string | null;
  last_updated_timestamp: string | null;
  type: string;
  state: ArticleState;
  refresh_failure_reason?: string | null;
  tags: string[];
  itemsCount: number;
  embed_state?: ArticleEmbedStateEnum;
  auto_refresh_enabled: boolean;
}

export type ArticleInput = Omit<Article, 'id' | 'created_timestamp' | 'state' | 'type'>;

export type Articles = Article[];

export interface ArticlesList {
  items: Article[];
  offset: number;
  count: number;
}

export interface ArticlesPaginated {
  count: number;
  offset: number;
  items: Articles;
  nextOffset?: number;
  itemsCount: number;
}

export interface PDFInput {
  pdf_file: File;
}

export interface ErrorMessage {
  message: string;
}

export type Errors = ErrorMessage[];

export type ErrorType<Input> = {
  [K in keyof Input]?: Errors;
} & { root?: Errors };

export interface BackendError<Error> {
  errors: Error;
}

export enum DOWNLOAD_MODE {
  INDIVIDUAL = 'individual',
  INDIVIDUAL_WITH_SUMMARY = 'individual_with_summary',
  SITE_WIDE = 'site_wide',
}

export interface URLInput {
  url: string;
  mode: DOWNLOAD_MODE;
}

export type ArticleURLInputError = ErrorType<URLInput>;

export interface BackendSuccess<Input> {
  article: Input;
  status: string;
}

export enum FilterType {
  TITLE = 'Title',
  URL = 'URL',
  TYPES = 'Types',
  TAGS = 'Tags',
}

export enum ArticleSource {
  INTERCOM = 'Intercom',
  URL = 'URL',
  ARTICLE = 'Article',
  PDF = 'PDF',
}

export { RefreshableArticleType } from '@/Domain/utils/article';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Filter {
  type: FilterType;
  value: FilterValue;
}

interface FilterValue {
  searchQuery: string;
  [key: string]: string | boolean | string[] | undefined;
}

export interface IFormInputs {
  searchQuery: string;
  [key: string]: any;
}

export interface TagifyEventDetail {
  data: {
    value: string;
  };
}

export interface TagifyEvent {
  detail: TagifyEventDetail;
}

interface IntercomIntegration {
  has_token: boolean;
  has_articles: boolean;
}

export interface Integrations {
  intercom: IntercomIntegration;
  links: {
    public: string;
    preview: string;
    widget: string;
    embed: string;
  };
  tiers: Record<string, string>;
  slack: {
    old_integration_is_active: boolean;
  };
}
